import { el } from 'redom';

import AnchorButton from '../anchor-button';

class FieldInputAnchor {

  constructor(options) {

    this.fieldSelectorActive = false;
    this.field = options.field;
    this.fieldSelector = options.fieldSelector;
    this.onSelect = options.onSelect;
    this.onClose = options.onClose;

    this.anchor = new AnchorButton({
      placeholder: 'Select field',
      value: this.field.label,
      onClick: this.handleAnchorButtonClick.bind(this)
    });

    this.el = el('.field-input-anchor', [this.anchor]);

  }

  handleAnchorButtonClick() {

    this.toggleFieldSelector();

  }

  showSelector() {

    this.fieldSelector.show();
    this.fieldSelectorActive = true;

  }

  hideSelector() {

    this.fieldSelector.hide();
    this.fieldSelectorActive = false;
    this.anchor.close();

  }

  toggleFieldSelector() {

    const options = {
      field: this.field,
      scrollAnchorElement: this.el,
      onSelect: this.handleFieldSelect.bind(this),
      onClose: this.handleFieldSelectorClose.bind(this),
      placeholder: 'Search field',
      offset: {
        top: -47
      }
    };

    this.fieldSelector.reconfigure(options);

    if (this.fieldSelectorActive === false) {
      this.showSelector();
    } else {
      this.hideSelector();
    }

    this.fieldSelectorActive = (this.fieldSelectorActive === false);

  }

  setField(field) {

    this.field = field;

    this.anchor.configure({
      value: this.field.label
    });

  }

  handleFieldSelect(field) {

    this.setField(field);

    this.hideSelector();
    this.onSelect(field);

  }

  handleFieldSelectorClose() {

    this.hideSelector();
    this.onClose();

  }

}

export default FieldInputAnchor;